<template>
  <div>
    <div :id="'recent-news-' + news.id" class="community_event article">
      <div class="left-card">
        <a class="community_event_bg" :href="news.news_url">
          <img :data-src="news.metadata_image ? news.metadata_image : getDefaultEventCardBackground()" style="max-height: 135px; object-fit: cover;" class="lazyload" @error="replaceEventCardBackgroundDefault">
        </a>
        <div class="community_event_info">
          <a class="community_event_author"><span class="author_name">{{ news.author }}</span> | <span class="community_event_author_date">{{ getNewsDate }}</span></a>
          <a class="community_event_title left_event_title" :title="news.news_url" :href="news.news_url">{{ news.text_title }}</a>
          <div class="community_event_desc">
            <div class="community_event_desc_line">
              {{ news.description }}
            </div>
          </div>
          <div class="community_event_bar" />
          <a class="community_event_link" :href="routeNews(news)">View Article</a>
          <div class="community_event_bar_2" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { component } from '../../mixins/component';
import dayjs from 'dayjs';

export default {
  mixins: [component],
  props: {
    news: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
    };
  },
  computed: {
    getNewsDate() {
      return dayjs(this.news.created_at, 'YYYY-MM-DD HH:mm:ss').format('MMMM DD, YYYY');
    },
  },
  created() {
  },
  methods: {
    routeNews(news) {
      var newsId = news.alias ? news.alias : news.id;
      return this.appConfig.baseUrl + '/news/' + newsId;
    },
  },
};
</script>
